<template>
    <div class="w-100 d-flex">


        <img :src="src" @load="imageLoaded = true" @error="imageError"
            :style="{ width: imageLoaded ? '' : '0px !important' }" class="w-100" />

        <img v-if="!imageLoaded" :src="AppConfigs.staticImages.OFFERGENERICIMAGE" alt="Offer Image" class="w-100"/>



    </div>
</template>





<script lang="ts">

import { AppConfigs } from "@/app.configs";
import { defineComponent, ref } from 'vue';

export default defineComponent({
    name: 'SafeImage',
    props: {
        src: {
            type: String,
            required: true,
        },
    },
    setup() {
        const imageLoaded = ref(false);

        const imageError = () => {
            imageLoaded.value = false;
        };

        return { imageLoaded, imageError, AppConfigs };
    },
});
</script>
